import { IExperience } from '../../CandidateGroup/types';

export const groupExperienceByCompany = (experiences: IExperience[]) => {
  const experienceGroups = [];
  let currentGroup: IExperience[] = [];
  let currentCompany = '';

  experiences.forEach((experience) => {
    const company = experience.company;
    if (company !== currentCompany) {
      if (currentCompany) {
        experienceGroups.push({ company: currentCompany, experiences: currentGroup });
      }
      currentGroup = [];
      currentCompany = company;
    }
    currentGroup.push(experience);
  });
  experienceGroups.push({ company: currentCompany, experiences: currentGroup });
  return experienceGroups;
};
